<template>
  <div id="headNav">
    <p v-wave class="nav" :class="[item.status ? 'navActive' : '']" v-for="item in navList" :key="item.value" @click="navActiveChange(item)">
      <i :class="item.icon"></i>
      {{$t(item.name)}}
    </p>
  </div>
</template>

<script>
import EventBus from '@/store/eventBus'
export default {
  name: "headNav",
  data() {
    return {
      navList: [
        {
          name: '按键映射',
          value: '0',
          status: true,
          icon: 'el-icon-edit'
        },
        {
          name: '高级按键',
          value: '4',
          status: false,
          icon: 'el-icon-s-promotion'
        },
        {
          name: '性能设置',
          value: '1',
          status: false,
          icon: 'el-icon-set-up'
        },
        {
          name: '灯光设置',
          value: '2',
          status: false,
          icon: 'el-icon-s-opportunity'
        },
        {
          name: '按键校准',
          value: '3',
          status: false,
          icon: 'el-icon-aim'
        }
      ]
    }
  },
  methods: {
    navActiveChange(obj) {
      this.navList.forEach(e => {
        e.status = obj.value === e.value;
        EventBus.$emit('navActiveChange',obj)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #headNav {
    display: flex;
    width: 100%;
    .nav {
      width: 25%;
      height: 0.4rem;
      line-height: 0.4rem;
      text-align: center;
      margin-right: 0.05rem;
      box-shadow: 0 0.06rem 0.12rem rgba(0,0,0,0.5);
      transition: all 0.3s;
      font-size: 0.15rem;
      @include background_color('background_color_sidebar')
    }
    .navActive {
      color: #409EFF;
    }
    .nav:hover {
      transform: translateY(-0.1rem) scale(1.01,1.01);
      box-shadow: 0 0.1rem 0.2rem rgba(0,0,0,0.3);
    }
    .nav:first-child {
      border-radius: 0.4rem 0 0 0.4rem;
    }
    .nav:last-child {
      border-radius: 0 0.4rem 0.4rem 0;
    }
  }
</style>
